// PROPOSITO: las rutas de la alumna. Un archivo de rutas por rol, desde el dia 1.
// DEPENDENCIAS: react-router-dom, AlumnaLayout, Guard.
// NO OBVIO: todas perezosas. El paquete inicial tiene tope de 250 KB y el panel de la entrenadora
// no puede viajar en el telefono de una alumna que nunca lo va a abrir.

import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Guard } from './Guard'
import { AlumnaLayout } from '@/layouts/AlumnaLayout'

const RutinaDeHoy = lazy(() => import('@/pages/alumna/RutinaDeHoy'))
const MiComidaDeHoy = lazy(() => import('@/pages/alumna/MiComidaDeHoy'))
const MiProgreso = lazy(() => import('@/pages/alumna/MiProgreso'))
const MiPerfil = lazy(() => import('@/pages/alumna/MiPerfil'))
const MiFicha = lazy(() => import('@/pages/alumna/MiFicha'))

export const rutasDeAlumna: RouteObject[] = [
  {
    element: <Guard permitidos={['alumna']} />,
    children: [
      {
        element: <AlumnaLayout />,
        children: [
          { path: '/hoy', element: <RutinaDeHoy /> },
          { path: '/comida', element: <MiComidaDeHoy /> },
          { path: '/progreso', element: <MiProgreso /> },
          { path: '/perfil', element: <MiPerfil /> },
          { path: '/perfil/ficha', element: <MiFicha /> },
        ],
      },
    ],
  },
]
